var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn',{attrs:{"gray":""},on:{"click":_vm.startBuilding}},[_vm._v(" "+_vm._s(_vm.$t('AI_BUILD'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }